import type { CardTag } from 'src/features/memberships/types';

enum CARD_TYPES {
    NORMAL = 'NORMAL',
    MEMBERSHIP = 'MEMBERSHIP',
    SERVICE = 'SERVICE',
    VIP = 'VIP',
    OPERATOR = 'OPERATOR',
    PREPAID = 'PREPAID',
    PREPAID_S = 'PREPAID_S',
    UNKNOWN = 'UNKNOWN',
}

enum OCCUPANCY_CARD_TYPE {
    NORMAL = 'NORMAL',
    VIP = 'VIP',
    PREPAID = 'PREPAID',
    ALL = 'ALL',
}

enum PAYMENT_METHODS {
    cash = 'cash',
    card = 'card',
    bank = 'bank',
}

enum GUEST_REASONS {
    ticketValidation = 'ticket-validation',
    exitOpen = 'exit-open',
}

interface InParkingCard {
    id: number;
    uuid: string;
    card_number: string;
    card_type: CARD_TYPES;
    plate_number: string;
    owner_name: string;
    card_group_id?: string | number | null;
    card_group_name?: string | null;
    enter_datetime: string;
    parking_id: string;
    parking_name: string;
    entry_point: string;
    charge_plan_id?: number | null;
    charge_plan_name?: string | null;
    photo_path?: string | null;
    tags: CardTag[];
    is_guest: boolean;
}

interface InParkingCardDetail {
    card_number: string;
    card_name: string;
    card_type: CARD_TYPES;
    membership_group_id?: number;

    in_parking: boolean;
    in_parking_card_id: number;

    enter_datetime: string;
    calculation_datetime: string;

    duration: number;
    due_amount: number;
    due_amount_with_tax: number;
    tax_amount: number;
    vat: number;

    pricing_plan_id?: number;
    pricing_plan_name?: string;
    status: string;

    exit_time: number;
    exit_valid: boolean;

    parking_id: string;
    photo_path: string;

    is_guest: boolean;
}

export {
    type InParkingCard,
    type InParkingCardDetail,
    CARD_TYPES,
    PAYMENT_METHODS,
    GUEST_REASONS,
    OCCUPANCY_CARD_TYPE,
};
